import toastr from 'toastr';
import Service from '../../../utility/Service';

export const PROMOCODE_GET_SUCCESS = "PROMOCODE_GET_SUCCESS";
export const PROMOCODE_GET_FAILURE = "PROMOCODE_GET_FAILURE";
export const PROMOCODE_GET_REQUEST = "PROMOCODE_GET_REQUEST";

export const promoCodeGetFailure = () => ({
    type: PROMOCODE_GET_FAILURE,
    loading: true,
    promoCodeData: []
});

export const promoCodeGetSuccess = (data, pageNo, pageSize) => ({
    type: PROMOCODE_GET_SUCCESS,
    loading: false,
    promoCodeData: data
});

export const promoCodeGetRequest = () => ({
    type: PROMOCODE_GET_REQUEST,
    loading: true,
    promoCodeData: []
});

export const getPromoCode = (id, pageNo, pageSize) => (dispatch, getState) => {
    toastr.remove()
    dispatch(promoCodeGetRequest())
    let url = "promo_code/" + id
    Service.get(url,
        (response) => {
            if (response && response.status && response.status === 200) {
                let data = {
                    data: response.data,
                    pagination: response.pagination
                }
                dispatch(promoCodeGetSuccess(data));
            } else {
                dispatch(promoCodeGetFailure());
                toastr.error('Something Went Wrong');
            }
        }
    )
};